import { Component, OnInit } from '@angular/core';
import { BookingService } from "../../../shared/services/booking.service";
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ThrowStmt } from '@angular/compiler';
import { endOfMonth } from 'date-fns';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-booking-management',
  templateUrl: './booking-management.component.html',
  styleUrls: ['./booking-management.component.scss']
})
export class BookingManagementComponent implements OnInit {
pagination= [];
ranges = { "اليوم": [new Date(), new Date()],
'الشهر الحالي': [ new Date(new Date().getFullYear(), new Date().getMonth(), 1), endOfMonth(new Date())]
,  'الإسبوع الحالي': [ new Date(new Date().setDate(new Date().getDate() - new Date().getDay())), new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+6))]};
currentPage: any = 1;
todayDate = [new Date(), new Date()];
pageSize: any = 10;
  appointmentsList = [];
isAppointmentsLisLoading: boolean = false;
  appointmentStatus:any;
  appointmentـStatus:any;
  invoice:any = null;
  paymentStatusMSG:any;
  invoiceMSG:any;
  paymentـStatus: any;
  code: any;
  paymentStatus: any;
  isAppointmentsLisLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isAppointmentStatusVisible = false;
  isPaymentStatusVisible = false;
  AppoId:any;
  search:"";
  startDate: any = new Date();
  endDate: any = new Date();
 date = null;


 
  showAppointmentStatusModal(id: any , appointmentStatus: any): void {
    this.AppoId = id;
    this.appointmentStatus= appointmentStatus;
    this.isAppointmentStatusVisible = true;
  }

  handleAppointmentStatusOk(): void {
    this.isAppointmentStatusVisible = false;
  }

  handleAppointmentStatusCancel(): void {
    this.isAppointmentStatusVisible = false;
  }


  showPaymentStatusModal(item): void {

    this.AppoId = item['id'];
    this.invoice = item['invoice'];
    this.paymentStatus=  item['payment_status'];
    this.code =  item['code'];
    this.isPaymentStatusVisible = true;
  }

  handlePaymentStatusOk(): void {
    this.isPaymentStatusVisible = false;
  }

  handlePaymentStatusCancel(): void {
    this.isPaymentStatusVisible = false;
  }


  constructor(public bookingService: BookingService,
    private message: NzMessageService,
    public datepipe: DatePipe

  ) {

  }


  changeAppointmentStatus(ev: any) {
    this.appointmentـStatus = ev;
    this.getAllappointments();

  }

  changePaymentStatus(ev: any) {
    this.paymentـStatus = ev;
    this.getAllappointments();

  }


  ngOnInit(): void {
    this.getAllappointments();
    // this.rows = [
    //   { description: 'Avg. Client Rating' },
    //   { description: 'Instagram Followers' },
    //   { description: 'Google Ads CPC' },
    // ];



  }

  pageSizeChange(e){
      this.pageSize = e;

    this.getAllappointments();
  }
  pageChange(e){
      this.currentPage = e;
    this.getAllappointments();
  }

  pagenation=[];
  async getAllappointments() {
    const startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd');
    const endDate = this.datepipe.transform( this.endDate, 'yyyy-MM-dd');

    this.isAppointmentsLisLoading$.next(true);


    let params;
    console.log("DDDDDDDDDDD");
      console.log(this.currentPage);

      console.log(this.pageSize);
    params= {
      page  :  this.currentPage ,
      pageSize :  this.pageSize ,
      start_date  : startDate,
      end_date  :endDate,
      payment_status: this.paymentـStatus,
      status: this.appointmentـStatus,
    }
    let o = Object.keys(params)
    .filter((k) => params[k] != null)
    .reduce((a, k) => ({ ...a, [k]: params[k] }), {});


    this.isAppointmentsLisLoading=true;
    this.bookingService.getAllappointments(o).subscribe({
      next: (response: any) => {
        this.isAppointmentsLisLoading=false;
        this.appointmentsList = response?.data;
        this.pagenation = response?.pagination;
  this.pagination = response?.pagination

      },
      error: (error) => {
        this.isAppointmentsLisLoading=false;
      }
    }
    );

  }



  SetPaymentStatus(e:any): void {
    this.paymentStatus = e;
  }


 isEmpty(val){
    return (val === undefined || val == null || val.length <= 0) ? true : false;
}

textChange(){
  this.invoiceMSG = "";
}
  updatePaymentStatus() {

    console.log(this.paymentStatus)
    console.log(this.invoice)
    if(this.isEmpty(this.paymentStatus)){
      this.paymentStatusMSG = "هذا الحقل إلزامي"
    }

    if(this.isEmpty(this.invoice)){
      this.invoiceMSG = "هذا الحقل إلزامي"
    }

    if(this.invoice &&  this.paymentStatus){
    let params: any;
    params = {
      "appointment_id":this.AppoId,
      "status":  this.paymentStatus.toString(),
      "invoice": this.invoice

    }
    this.bookingService.changePaymentStatus(params).subscribe(
      (res: any) => {
        this.message.success(res.message);
        this.isAppointmentStatusVisible = false;
        this.isPaymentStatusVisible = false;
        this.getAllappointments();
      },
      (err) => {

        this.message.error(err.message);
      }
    );
  }
  }


  SetAppointmentStatus(e:any): void {
    this.appointmentStatus = e;
  }

  async updateAppointmentStatus() {
    let params = {
      "appointment_id": this.AppoId,
      "status":this.appointmentStatus.toString()
    };
    this.bookingService.ChangeAppointmentStatus(params).subscribe(
      (res: any) => {
        this.message.success(res.message);
        this.isAppointmentStatusVisible = false;
        this.isPaymentStatusVisible = false;
        this.getAllappointments();
      },
      (err) => {
        this.message.error(err.message);
      }
    );

  }

  deleteAppointments(id: any) {
    this.bookingService.DeleteAppointments(id).subscribe(
      (res: any) => {
        this.getAllappointments()
        this.message.success(res.message);
      }, err => {
        this.message.success(err.error.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      }
    );
  }


  deleteall() {
    this.bookingService.delete_all().subscribe(
      (res: any) => {
        this.getAllappointments()
        this.message.success(res.message);
      }, err => {
        this.message.success(err.error.description, {
          nzDuration: 3000,
          nzAnimate: true,
        });
      }
    );
  }

  onChangeDate(result: Date[]): void {
    this.startDate = result[0];
    this.endDate = result[1];
    this.getAllappointments();

    }


    addHours(timeString) {
      let dt = new Date('1970-01-01T' + timeString);
      dt.setHours(dt.getHours() + 1);
      let TimeAddHour = dt.toLocaleTimeString([], { hour: "numeric", minute: "numeric", hour12: true });
      console.log(typeof TimeAddHour)
      
      return TimeAddHour ;
    }
  
  
    tConvert(timeString) {
      const timeString12hr = new Date('1970-01-01T' + timeString )
        .toLocaleTimeString([],
          { hour: 'numeric', minute: 'numeric' , hour12: true}
        );
      return timeString12hr 
    }
  

}
